document.addEventListener('DOMContentLoaded', function() {
  // Gestion des boutons de quantité
  const quantityButtons = document.querySelectorAll('.quantity-button');
  
  quantityButtons.forEach(button => {
    button.addEventListener('click', function() {
      const input = this.parentNode.querySelector('.quantity-input');
      const currentValue = parseInt(input.value);
      
      if (this.classList.contains('minus')) {
        if (currentValue > 1) {
          input.value = currentValue - 1;
        }
      } else if (this.classList.contains('plus')) {
        input.value = currentValue + 1;
      }
      
      // Déclencher la mise à jour du panier
      setTimeout(() => {
        const form = document.getElementById('cart');
        if (form) {
          const updateButton = document.createElement('input');
          updateButton.type = 'hidden';
          updateButton.name = 'update';
          updateButton.value = 'Update';
          form.appendChild(updateButton);
          form.submit();
        }
      }, 300);
    });
  });
  
  // Fonctionnalité pour les produits récemment consultés
  // Cette partie nécessite une implémentation personnalisée selon vos besoins
});
